import { userStateData } from '../../data/userStateData'

import './style.scss'
import { PAGE_URLS } from '../../constants/hrefLinks'
import { useCookies } from 'react-cookie'

function UserPopUp() {

	const [cookies, setCookie, removeCookie] = useCookies(['userData'])

	const logoutClickHandler = () => {
		userStateData.logOut()
		removeCookie("userData",{
			path: "/"
		})
		window.location.replace(PAGE_URLS.APP_ENTRY)
	}

	return (
		<div className="user-popup-wrap">
			<div
				className='user-popup-name'
				// onClick={() => {
				// 	// if (!userStateData.isAnInstructor()) {
				// 		// window.location.replace(`${PAGE_URLS.DASHBOARD_CUSTOMER}?user=customer2`)
				// 		// window.location.replace(`${PAGE_URLS.DASHBOARD_CUSTOMER}?user=${userStateData.isAnInstructor() ? 'instructor2' : 'customer2'}`)
				// 	// }
				// }}
			>{userStateData.getUsersName()}</div> 
			<a
				className='user-popup-button'
				href={`${PAGE_URLS.DASHBOARD_CUSTOMER}`}
			>Dashboard</a>
			<div
				className='user-popup-button'
				// href={'/'}
				onClick={() => logoutClickHandler()}
			>Logout</div>
		</div>
	)
}

export default UserPopUp
